<template>
  <v-combobox 
    class="ma-0 pa-0 rounded-lg app-doc-combobox-outlined"
    outlined
    :multiple="multiple"
    :disabled="disabled"
    :label="label"
    :items="items"
    :value="value"
    :error="error"
    :readonly="readonly"
    :dense="dense"
    :hide-details="hideDetails"
    :hint="hint"
    :rules="rules"
    :append-icon="appendIcon"
    :error-messages="errorMessages"
    :item-text="itemText"
    :item-value="itemValue"
    :filter="filter"
    :small-chips="smallChips"
    @input.native="e => $emit('input.native', e)"
    @click="e => $emit('click', e)"
    @blur="e => $emit('blur', e)"
    @mouseup="e => $emit('mouseup', e)"
    @change="e => $emit('change', e)"
    @focus="e => $emit('focus', e)"
    @input="e => $emit('input', e)"
    @click:append="e => $emit('click:append', e)"
    @keydown="e => $emit('keydown', e)"
  >
    <template v-slot:item="data">
      <slot name="item" v-bind="data">
        {{ data.item[itemText] }}
      </slot>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'AppCombobox',

  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    cacheItems: {
      type: Boolean,
      default: false,
    },
    value: {
      default: undefined,
    },
    error: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    smallChips: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    appendIcon: {
      type: String,
      default: '$dropdown',
    },
    errorMessages: {
      type: [String, Array],
      default: () => [],
    },
    itemText: {
      type: [String, Array, Function],
      default: 'text'
    },
    itemValue: {
      type: [String, Array, Function],
      default: 'value'
    },
    filter: {
      type: Function,
    },
  }

}
</script>

<style>
.app-doc-combobox-outlined.v-text-field--outlined fieldset {
  border: none !important;
} 

.app-doc-combobox-outlined > .v-input__control > .v-input__slot   {
  -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
  box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
}

.app-doc-combobox-outlined.v-input--is-dirty > .v-input__control > .v-input__slot,
.app-doc-combobox-outlined > .v-input__control > .v-input__slot {
  padding-left: 10px !important;
}

.app-doc-combobox-outlined  > div > .v-input__slot  {
  border: solid 1px var(--v-primary-base) !important;
  color: transparent !important; 
  height: 60px !important;
}
.app-doc-combobox-outlined.v-select--is-multi > div > .v-input__slot {
  height: auto !important;
  min-height: 60px;
}

.app-doc-combobox-outlined.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > label,
.app-doc-combobox-outlined.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > label {
    color:  var(--v-primary-base);
    font-weight: 600;
}

.app-doc-combobox-outlined.v-input--is-dirty > .v-input__control > .v-input__slot,
.app-doc-combobox-outlined.v-input--is-focused  > .v-input__control > .v-input__slot {
  padding-top: 16px !important;
}

.app-doc-combobox-outlined  > .v-input__control > .v-input__slot::before {
    border: none !important;
}

.app-doc-combobox-outlined.error--text  > div > .v-input__slot  {
  border-color: var(--v-error-base) !important;
}

.app-doc-combobox-outlined.v-input--is-disabled  > .v-input__control > .v-input__slot {
  border-color: #c2c2c2 !important;
}

.app-doc-combobox-outlined.v-input--is-disabled  > .v-input__control > .v-input__slot > .v-select__slot > label {
  color: #c2c2c2 !important;
}
</style>